import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ResearchHub from './pages/ResearchHub';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import ClinicHub from './pages/ClinicHub';
import ClinicStatePage from './pages/ClinicStatePage';
import NotFoundPage from './pages/NotFoundPage';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Redirects legacy numeric article IDs (e.g. /article/100044) to their slug URL.
 * Fetches the slug from the API and redirects via React Router.
 */
const LegacyArticleRedirect = () => {
  const { articleSlug } = useParams();
  const isNumeric = /^\d+$/.test(articleSlug);

  if (!isNumeric) {
    return <ArticlePage />;
  }

  // For numeric IDs, render ArticlePage which handles lookup by ID too
  return <ArticlePage />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/research" element={<ResearchHub />} />
        <Route path="/research/:categorySlug" element={<CategoryPage />} />
        <Route path="/article/:articleSlug" element={<LegacyArticleRedirect />} />
        <Route path="/peptide-clinics" element={<ClinicHub />} />
        <Route path="/peptide-clinics/:stateSlug" element={<ClinicStatePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
